// @flow
import { getStateCurrentValue, type State } from 'app/common/ui-components/filter'

import { filterId } from './filterId'

export const splitByDaysChecked = (state: State): boolean => {
  const [checked] = getStateCurrentValue(filterId, state) || []
  return !!checked
}
